import { Aspect as t } from "./index5.js";
const s = {
  aspect: {
    aspect: t.CUSTOM,
    isLocked: !1
  }
};
export {
  s as initialState
};
